<template>
    <v-list nav dense>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/invitacion_tab">
            <v-list-tile-action>
                <v-icon medium>event</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Invitaciones')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/records_no_code">
            <v-list-tile-action>
                <v-icon medium>date_range</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Historial')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router :to="companiesRoute">
            <v-list-tile-action>
                <v-icon medium>business</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Empresas')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                v-if="isBuilding"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/corporate-building/offices">
            <v-list-tile-action>
                <v-icon medium>meeting_room</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile><h3>Oficinas</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="isBuilding"></v-divider>
        <v-list-tile
                v-if="isBuilding"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/corporate-building/facial-devices">
            <v-list-tile-action>
                <v-icon medium>sensor_door</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile><h3>Control de Acceso</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="isBuilding"></v-divider>
                <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                @click="toggleEstacionamiento">
            <v-list-tile-action>
                <v-icon medium>local_parking</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile><h3>Estacionamiento</h3></v-list-tile>
            </v-list-tile-content>
            <v-list-tile-action>
                <v-icon>{{ showEstacionamientoMenu ? 'expand_less' : 'expand_more' }}</v-icon>
            </v-list-tile-action>
        </v-list-tile>

        <v-slide-y-transition>
            <div v-if="showEstacionamientoMenu">
                <v-list-tile
                        class="tile ml-4"
                        active-class="blue-grey darken-1 white--text"
                        router to="/corporate-building/parking-spaces-management">
                    <v-list-tile-action>
                        <v-icon small>add_circle_outline</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile><h4>Crear Espacios</h4></v-list-tile>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                        class="tile ml-4"
                        active-class="blue-grey darken-1 white--text"
                        router to="/corporate-building/parking-cards-management">
                    <v-list-tile-action>
                        <v-icon small>credit_card</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile><h4>Tarjetas de Acceso</h4></v-list-tile>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                        class="tile ml-4"
                        active-class="blue-grey darken-1 white--text"
                        router to="/corporate-building/parking-spaces-assignment">
                    <v-list-tile-action>
                        <v-icon small>assignment</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile><h4>Asignar a Empresas</h4></v-list-tile>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                        class="tile ml-4"
                        active-class="blue-grey darken-1 white--text"
                        router to="/corporate-building/parking-spaces-status">
                    <v-list-tile-action>
                        <v-icon small>visibility</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile><h4>Estado en Tiempo Real</h4></v-list-tile>
                    </v-list-tile-content>
                </v-list-tile>
            </div>
        </v-slide-y-transition>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/link-company">
            <v-list-tile-action>
                <v-icon medium>security</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile><h3>Empresas de Seguridad</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/caseta_parque">
            <v-list-tile-action>
                <v-icon medium>local_convenience_store</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Casetas')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/vigilante_parque">
            <v-list-tile-action>
                <v-icon medium>assignment_ind</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Vigilantes')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/configuracion">
            <v-list-tile-action>
                <v-icon medium>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('configuracion')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/ayuda_admin">
            <v-list-tile-action>
                <v-icon medium>help</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile><h3>{{$t('Ayuda')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "admin_parque",
        computed: {
          ...mapGetters(['getProfile']),
          isBuilding() {
              return !!(this.getProfile && this.getProfile.is_building === true)
          },
          companiesRoute() {
              return this.isBuilding ? '/corporate-building/company-onboarding' : '/companiesByPark'
          }
        },
        data () {
            return {
                showEstacionamientoMenu: false
            }
        },
        methods: {
            toggleEstacionamiento() {
                this.showEstacionamientoMenu = !this.showEstacionamientoMenu
            }
        }
    }
</script>


<style scoped>
    .tile {
        margin: 5px;
        border-radius: 4px;
    }
</style>
